import { useMemo } from 'react';
import classNames from 'classnames';
import Select from '@UI/New/Select';
import s from "./index.module.css";
import { ExpandDropDownList } from '@/utils/icons';

const Pagination = ({setPerPage, perPage, currentPage, setCurrentPage, nextPage, prevPage, totalPages, compact = false, className = '', maxPerPage = 1000}) => {
    const options = useMemo(()=>{
        return (
            [
                { label: compact ? "20 / стр." : "20 на странице", value: 20 },
                { label: compact ? "50 / стр." : "50 на странице", value: 50 },
                { label: compact ? "100 / стр." : "100 на странице", value: 100 },
                { label: compact ? "500 / стр." : "500 на странице", value: 500 },
                { label: compact ? "1000 / стр." : "1000 на странице", value: 1000 },
                // { label: "Все", value: 'all' },
            ].filter((option) => option.value <= maxPerPage)
        )
    }, [compact, maxPerPage]);

    const getPaginationItems = () => {
        const paginationItems = [];

        paginationItems.push(1);

        let start = Math.max(2, currentPage - 1);
        let end = Math.min(totalPages - 1, currentPage + 1);

        if (start > 2) {
            paginationItems.push('...');
        }

        for (let i = start; i <= end; i++) {
            paginationItems.push(i);
        }

        if (end < totalPages - 1) {
            paginationItems.push('...');
        }

        if (totalPages > 1) {
            paginationItems.push(totalPages);
        }

        return paginationItems;
    };
    const paginationItems = useMemo(()=>{
        return getPaginationItems();
    }, [currentPage, totalPages]);

    return (
           <div className={classNames(s.wrapper, compact && s.compact, className)}>
                <Select
                    hideSearchIcon
                    compact={compact}
                    className={s.pageSelectionSelect}
                    wrapperClassName={s.pageSelection}
                    fields={{
                        showSearch: false,
                        'aria-label': 'Количество записей на странице',
                        value: perPage,
                        options,
                        onChange: (value) => {
                            setPerPage(value);
                            setCurrentPage(1);
                        },
                    }}
                />
                <div className={s.wrapperPagination}>
                    <div
                        className={classNames(s.prev, {[s.disable]:String(currentPage) === '1'})}
                        onClick={prevPage}
                    >
                        <ExpandDropDownList />
                    </div>

                    {paginationItems.map((item, index) => (
                          <div
                            key={index}
                            onClick={() => {
                                if( typeof item !== 'number' ) return;
                                setCurrentPage(item)
                            }}
                            className={classNames( {[s.item]: typeof item === 'number'}, {[s.itemActive]: item === currentPage})}>{item}</div>
                    ))}

                    <div
                        className={classNames(s.next, {[s.disable]:Number(currentPage) === Number(totalPages)})}
                        onClick={nextPage}
                    >
                        <ExpandDropDownList />
                    </div>
                </div>
           </div>
    )
}

export default Pagination;
